interface ChatPopupProps {
  onClose: () => void;
}

const ChatPopup = ({ onClose }: ChatPopupProps) => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/5519981868997', '_blank');
  };

  return (
    <div className="fixed bottom-24 right-4 z-50 max-w-sm">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 overflow-hidden">
        <div className="bg-green-500 text-white p-3 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-customer-service-2-line text-sm"></i>
            </div>
            <div>
              <div className="font-semibold text-sm">Desentupidora da Cidade Nº1</div>
              <div className="text-xs opacity-90">Online agora</div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="p-4 bg-gray-50 min-h-[120px]">
          <div className="flex items-start space-x-2 mb-3">
            <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-customer-service-2-line text-white text-xs"></i>
            </div>
            <div className="bg-white rounded-lg px-3 py-2 shadow-sm max-w-xs">
              <p className="text-sm text-gray-800">
                Olá, temos equipe próxima da sua região! Gostaria de uma Visita e Orçamento{' '}
                <strong>100% GRATUITO</strong>? Vamos agendar?
              </p>
            </div>
          </div>

          <div className="flex justify-end space-x-2 mt-3">
            <button
              onClick={onClose}
              className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
            >
              Depois
            </button>
            <button
              onClick={handleWhatsApp}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-1"></i>
              Sim, quero!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatPopup;